const sections = [
  { id: 'hero',         theme: 'dark',  displayKey: 'PLANETARY' },
  { id: 'identity',     theme: 'dark',  displayKey: 'nav.identity' },
  { id: 'cosmos',       theme: 'dark',  displayKey: 'nav.ecosystem' },
  { id: 'verse',        theme: 'dark',  displayKey: 'nav.verse' },
  { id: 'capabilities', theme: 'dark',  displayKey: 'nav.expertise' },
  { id: 'thinking',     theme: 'dark',  displayKey: 'nav.process' },
  { id: 'services',     theme: 'dark',  displayKey: 'nav.services' },
  { id: 'stack',        theme: 'dark',  displayKey: 'nav.stack' },
  { id: 'toolkit',      theme: 'dark',  displayKey: 'nav.instruments' },
  { id: 'metrics',      theme: 'dark',  displayKey: 'nav.vitals' },
  { id: 'statement',    theme: 'coral', displayKey: 'nav.manifest' },
  { id: 'principles',   theme: 'dark',  displayKey: 'nav.values' },
  { id: 'connect',      theme: 'dark',  displayKey: 'nav.orbit' },
  { id: 'outro',        theme: 'dark',  displayKey: 'nav.expansion' },
];

export default sections;
